export default "__VITE_ASSET__BAjyfJbV__"